import {
  SET_SOURCEOFFUND,
  GET_ALLOWED_SOURCEOFFUNDS_REQUEST,
  GET_ALLOWED_SOURCEOFFUNDS_SUCCESS,
  GET_ALLOWED_SOURCEOFFUNDS_FAILURE,
  CLEANUP,
} from "./selectSourceOfFundType";

const initialState = {
  loading: false,
  sourceOfFund: null,
  allowedSourceOfFunds: [],
  error: "",
};

const selectSourceOfFundReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEANUP: {
      return initialState;
    }

    case SET_SOURCEOFFUND: {
      return {
        ...state,
        sourceOfFund: action.sourceOfFund,
      };
    }

    case GET_ALLOWED_SOURCEOFFUNDS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_ALLOWED_SOURCEOFFUNDS_SUCCESS: {
      return {
        ...state,
        loading: false,
        allowedSourceOfFunds: action.payload,
        error: "",
      };
    }

    case GET_ALLOWED_SOURCEOFFUNDS_FAILURE: {
      return {
        ...state,
        loading: false,
        allowedSourceOfFunds: [],
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

export default selectSourceOfFundReducer;
